import { useEffect, useState } from "react";
import { NavContext } from "src/context/NavContext";

import { SSRProvider, ToastContainer } from "react-bootstrap";
import { IntlProvider } from "react-intl";
import TopBarProgress from "react-topbar-progress-indicator";
import AOS from "aos";

import Router, { useRouter } from "next/router";
import Head from "next/head";
import dynamic from "next/dynamic";
import Script from "next/script";
import "bootstrap/dist/css/bootstrap.min.css";

import "../styles/globals.scss";

const Layout = dynamic(() => import("src/components/Layout/Layout"));

// Load locale messages synchronously
const messages = {
  ar: require("../public/static/locales/ar.json"),
  en: require("../public/static/locales/en.json"),
};

function MyApp({ Component, pageProps, footerLinks }) {
  const [progress, setProgress] = useState(false);
  const [navData, setNavData] = useState(
    pageProps?.footerSettings || pageProps?.footerData || {}
  );
  const [servicesData, setServicesData] = useState([]);
  const router = useRouter();
  const { locale, defaultLocale, asPath } = router;
  const currentMessages = messages[locale] || messages.ar;
  const dir = locale === "ar" ? "rtl" : "ltr";
  const faviconPath =
    pageProps?.footerSettings?.AppSetting?.favicon ||
    pageProps?.footerData?.AppSetting?.favicon;

  TopBarProgress.config({
    barColors: {
      0: "#E90000",
      "1.0": "#830000",
    },
    shadowBlur: 1,
    barThickness: 4,
  });

  Router.events.on("routeChangeStart", () => {
    setProgress(true);
  });

  Router.events.on("routeChangeComplete", () => {
    setProgress(false);
  });

  useEffect(() => {
    if (pageProps?.footerSettings || pageProps?.footerData) {
      setNavData(pageProps.footerSettings || pageProps.footerData);
    }
  }, [pageProps?.footerSettings, pageProps?.footerData]);

  useEffect(() => {
    document.documentElement.dir = dir;
    document.body.style.direction = dir;
    document.body.setAttribute("dir", dir);
  }, [dir]);

  // GTM setup
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
  }, []);

  useEffect(() => {
    // Defer AOS until after page is interactive
    if (typeof window !== "undefined") {
      const initAOS = () => {
        if (window.innerWidth < 768) return; // Skip on mobile

        import("aos/dist/aos.css")
          .then(() => {
            AOS.init({
              duration: 600,
              once: true,
              offset: 50,
              delay: 0,
              throttleDelay: 99,
              disableMutationObserver: true,
            });
          })
          .catch(() => {});
      };

      // Defer to idle time
      if ("requestIdleCallback" in window) {
        requestIdleCallback(initAOS, { timeout: 2000 });
      } else {
        setTimeout(initAOS, 1000);
      }
    }
  }, []);

  useEffect(() => {
    const handleRouteChange = (url) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "pageview",
        page: url,
      });
    };

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const selectors = [
      'a[href^="https://wa.me"]',
      'a[href^="tel:"]',
      'a[href*="whatsapp"]',
    ];

    const elements = document.querySelectorAll(selectors.join(","));

    elements.forEach((el) => {
      el.addEventListener("click", function (e) {
        const url = el.getAttribute("href");
        e.preventDefault();
        gtag_report_conversion(url);
      });
    });
  }, []);

  return (
    <div>
      <SSRProvider>
        {progress && <TopBarProgress />}

      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="author" content="مؤسسة نور سين الأعمال لتقنية المعلومات" />
        <meta
          name="publisher"
          content="مؤسسة نور سين الأعمال لتقنية المعلومات"
        />
        <meta name="keywords" content="مواد تنظيف , تنظيف فلل , تنظيف شقق " />
        {/* <meta
          name="google-site-verification"
          content="WMWK8zXcJHQkuYvAILcnKqDl7Lg2eB8KbHKb71iMcmk"
        /> */}
        <link
          rel="icon"
          href={
            faviconPath
              ? `${process.env.NEXT_PUBLIC_API_URL}${faviconPath}`
              : "/favicon.ico"
          }
        />

        <link
          rel="alternate"
          href={`https://mu7.com.sa${asPath === "/" ? "" : asPath}`}
          hrefLang="ar"
        />
        <link
          rel="alternate"
          href={`https://mu7.com.sa/en${asPath === "/" ? "" : asPath}`}
          hrefLang="en"
        />
        <link
          rel="alternate"
          href={`https://mu7.com.sa${asPath === "/" ? "" : asPath}`}
          hrefLang="x-default"
        />
        <link
          rel="canonical"
          href={
            locale === "ar"
              ? `https://mu7.com.sa${asPath === "/" ? "" : asPath}`
              : `https://mu7.com.sa/en${asPath === "/" ? "" : asPath}`
          }
        />
      </Head>

      {/* Google Tag Manager - Deferred */}
      {/* <Script
        id="gtm"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-N7NWNDZ2');
          `,
        }}
      /> */}

      {/* تحميل gtag */}
      {/* <Script
        strategy="lazyOnload"
        src="https://www.googletagmanager.com/gtag/js?id=AW-16776451087"
      /> */}

      {/* init */}
      {/* <Script id="gtag-init">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-16776451087');
        `}
      </Script> */}

      {/* دالة التحويل */}
      {/* <Script id="gtag-conversion">
        {`
          function gtag_report_conversion(url) {
            var callback = function () {
              if (typeof(url) != 'undefined') {
                window.location = url;
              }
            };

            gtag('event', 'conversion', {
              'send_to': 'AW-16776451087/lQZfCJbjie4ZEI-o0b8-',
              'value': 1.0,
              'currency': 'SAR',
              'event_callback': callback
            });

            return false;
          }
        `}
      </Script> */}

        <NavContext.Provider value={{ navData, servicesData, setServicesData }}>
          <IntlProvider
            messages={currentMessages}
            locale={locale}
            defaultLocale={defaultLocale}
          >
            <Layout>
              <Component {...pageProps} />
            </Layout>
          </IntlProvider>
        </NavContext.Provider>
        <ToastContainer position="bottom-left" />
      </SSRProvider>
    </div>
  );
}

export default MyApp;
